import { createSlice } from "@reduxjs/toolkit";

const attendanceSlice = createSlice({
  name: "attendance",
  initialState: {
    isLoading: false,
    holidayList: [],
    currentHoliday: {},
    workingLocationList: [],
    currentWorkingLocation: {},
    shiftsList: [],
    currentShifts: {},
    leaveTypeList: [],
    currentLeaveType: {},
    leaveCategoryOption: [],
    gradeConfig: [],
    performList: [],
    bestamp: [],
    beleave: [],
    allBesmart: [],
    loginDevices: [],
    leaveTypeById: {},
    workInLocation:[]
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setHolidayList(state, action) {
      state.holidayList = action.payload;
    },
    setCurrentHoliday(state, action) {
      state.currentHoliday = action.payload;
    },
    setWorkingLocation(state, action) {
      state.workingLocationList = action.payload;
    },
    setCurrentWorkingLocation(state, action) {
      state.currentWorkingLocation = action.payload;
    },
    setShiftsList(state, action) {
      state.shiftsList = action.payload;
    },
    setCurrentShifts(state, action) {
      state.currentShifts = action.payload;
    },
    setLeaveTypeList(state, action) {
      state.leaveTypeList = action.payload;
    },
    setCurrentLeaveType(state, action) {
      state.currentLeaveType = action.payload;
    },
    setLeaveCategoryOption(state, action) {
      state.leaveCategoryOption = action.payload;
    },
    setGradeConfig(state, action) {
      state.gradeConfig = action.payload;
    },
    setPerformList(state, action) {
      state.performList = action.payload;
    },
    setBestamp(state, action) {
      state.bestamp = action.payload;
    },
    setBeleave(state, action) {
      state.beleave = action.payload;
    },
    setAllBesmart(state, action) {
      state.allBesmart = action.payload;
    },
    setLoginDevices(state, action) {
      state.loginDevices = action.payload;
    },
    setLeaveTypeById(state, action) {
      state.leaveTypeById = action.payload;
    },
    setWorkInLocation(state, action) {
      state.workInLocation = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setHolidayList,
  setCurrentHoliday,
  setWorkingLocation,
  setCurrentWorkingLocation,
  setShiftsList,
  setCurrentShifts,
  setLeaveTypeList,
  setCurrentLeaveType,
  setLeaveCategoryOption,
  setGradeConfig,
  setPerformList,
  setBestamp,
  setBeleave,
  setAllBesmart,
  setLoginDevices,
  setLeaveTypeById,
  setWorkInLocation
} = attendanceSlice.actions;
export default attendanceSlice.reducer;
